import DataTableV2PaginatedMobile from '@/agilis/mobile/DataTableV2PaginatedMobile/DataTableV2PaginatedMobile.vue'
import CustomerTable from '@/applications/sales/components/CustomerTable/CustomerTable'

export default {
  name: 'CustomerTableMobile',
  mixins: [CustomerTable],
  components: {
    DataTableV2PaginatedMobile
  }
}
